// Canonical public web domain for ALL shareable links (profile, invite, win, crew).
// Keep this as the single source of truth so shared/copied links never leak the
// preview URL or drift across components. Override via REACT_APP_PUBLIC_WEB_URL.
export const PUBLIC_WEB_URL = (process.env.REACT_APP_PUBLIC_WEB_URL || "https://www.virtustars.com").replace(/\/+$/, "");

// Bare domain for display (no protocol), e.g. "www.virtustars.com".
export const WEB_DOMAIN = PUBLIC_WEB_URL.replace(/^https?:\/\//, "");

export const profileUrl = (username) => `${PUBLIC_WEB_URL}/${username}`;
export const inviteUrl = (username) => `${PUBLIC_WEB_URL}/${username}?ref=${username}`;
export const crewUrl = (handle) => `${PUBLIC_WEB_URL}/crew/@${handle}`;

// Crawlable Open Graph share links (served by the API host): social apps fetch
// rich previews (cover art + title) and humans are redirected to the canonical page.
const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const ogVideoUrl = (id) => `${API_BASE}/api/og/video/${id}`;
export const ogCrewUrl = (id) => `${API_BASE}/api/og/crew/${id}`;
